import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import routesPath from 'config/routesPath';

import { UserStarIcon } from 'modules/leadQualifier/assets/UserStarIcon';

import * as S from './styles';

export function ActionButton() {
  const history = useHistory();
  const { currentDealer } = useSelector(state => state.dealerStore);

  if (!currentDealer.financingBancoPanEnabled) {
    return null;
  }

  return (
    <S.CustomButton
      variant="contained"
      startIcon={<UserStarIcon />}
      onClick={() => history.push(routesPath.leadQualifier)}
    >
      Qualificar lead
    </S.CustomButton>
  );
}
